import {AbstractFilePointResponse} from './abstracts/abstract-file-point-response';

export class SoundPointResponse extends AbstractFilePointResponse {

  public constructor() {
    super();
  }
}
